import { pxToRem } from 'utils/convert';
import { EMAIL, IN_APP, SMS, PUSH, WEB_PUSH, EMBEDDED, WHATS_APP } from 'constants/messageMediums';
import { CampaignState, CampaignTypeFilter } from 'modules/domains/campaign';

export enum MissionControlModule {
  USER_ACTIVITY = 'UserActivity',
  HEALTH_DASHBOARD = 'HealthDashboard',
  GOALS_DASHBOARD = 'GoalsDashboard',
}

/**
 * Maximum width of the sidebar on desktop.
 */
export const DESKTOP_SIDEBAR_WIDTH_VALUE = 350;

/**
 * Maximum width of the alerts module on desktop.
 */
export const DESKTOP_ALERTS_WIDTH_VALUE = 300;

/**
 * Maximum height of the health content area.
 */
export const MAX_HEALTH_CONTENT_HEIGHT = pxToRem(482);

/**
 * Minimum height of the dashboard card.
 */
export const MIN_DASHBOARD_CARD_HEIGHT = pxToRem(300);

/**
 * Preview key for accessing the homepage.
 */
export const HOMEPAGE_PREVIEW_KEY = 'mission-control';

/**
 * Used as a delimiter for generating filter sub-menu option IDs.
 */
export const FILTER_SUBMENU_OPTION_DELIMITER = '___SUBMENU___';

/**
 * Message mediums supported for campaigns metrics.
 */
export const CAMPAIGNS_METRICS_MEDIUMS = [EMAIL, IN_APP, SMS, PUSH, WEB_PUSH, EMBEDDED, WHATS_APP];

/**
 * Default campaign filters for system event goal metrics queries.
 * Includes all supported message mediums, running/finished states, and campaign types.
 */
export const DEFAULT_CAMPAIGN_FILTERS = {
  mediums: CAMPAIGNS_METRICS_MEDIUMS,
  states: [CampaignState.Running, CampaignState.Finished],
  types: [
    CampaignTypeFilter.Blast,
    CampaignTypeFilter.Eligibility,
    CampaignTypeFilter.FromWorkflow,
    CampaignTypeFilter.Triggered,
    CampaignTypeFilter.WithAI,
    CampaignTypeFilter.WithExperiment,
  ],
};
